import {UIElement} from '../ui-element'
import {DataObjectId, User as DataUser} from 'yougile-model'
import {UserObj} from '../user-obj'
import {Sync} from '../../../client/sync'
import {UserAvatar} from '../../../components/user-avatar'

export class User extends UIElement {
  private uiUserId: DataObjectId
  private uiSize: number

  constructor(companyId: DataObjectId, userId: DataObjectId, size: number) {
    super(companyId, undefined, undefined)
    this.uiUserId = userId
    this.uiSize = size || 18
  }

  public get user(): UserObj {
    return new UserObj(this.uiUserId, Sync.get({companyId: this.companyId}))
  }

  public set user(val: UserObj) {
    this.uiUserId = val.id
    this.refresh()
  }

  public get size(): number {
    return this.uiSize
  }

  public set size(val: number) {
    this.uiSize = val
    this.refresh()
  }

  public override render(el: HTMLElement): void {
    const user = Sync.get({companyId: this.companyId}).get(
      this.uiUserId
    ) as DataUser
    el.innerHTML = ''
    el.className = 'ui-user'
    UserAvatar.renderToElement(
      {
        user,
        withUserInfo: true,
        opacity: 1,
        size: this.uiSize
      },
      el
    )
    super.render(el)
  }
}
